export enum AccessRightMode {
    all,
    any
}

export interface IPermissions {
    [key: string]: boolean;
}

export type PermissionKey = string | number;

export interface IAccessRight<TPermissionKey> {
    name: string;
    mode: AccessRightMode;
    permissions: TPermissionKey[];
}
